import { CancelSubscriptionFnReq, CancelSubscriptionFnRes } from '@uploadcam/common';
import { Functions, httpsCallable } from 'firebase/functions';

export class CancelSubscriptionInteractor {
  private readonly cancelSubscriptionFn = httpsCallable<
    CancelSubscriptionFnReq,
    CancelSubscriptionFnRes
  >(this.functions, 'cancelSubscription');

  constructor(private readonly functions: Functions) {}

  public async execute(feedback: string): Promise<void> {
    await this.cancelSubscriptionFn({ feedback });
  }
}
